<template>
  <div>
    <v-dialog
      v-model="dialogPrincipal"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!-- En el encabezado y no flotante: el FAB tapaba la paginación de la tabla -->
      <template v-slot:activator="{ on, attrs }">
        <button
          type="button"
          class="rm-btn rm-btn-primario"
          data-testid="orden-nueva"
          v-bind="attrs"
          v-on="on"
          @click="dataInitFinOrden()"
        >
          <AppIcon name="plus" size="h-4 w-4" />
          Nueva orden
        </button>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn v-if="pagina != 2" icon dark @click="cerrarDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn v-else icon dark @click="pagina = 1">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{
            pagina == 1 ? "Nueva orden" : "Alta de cliente"
            }}
          </v-toolbar-title>
        </v-toolbar>
        <v-container fluid v-if="pagina == 1">
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1">Buscar Cliente</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="e1 > 2" step="2">Buscar Vehículo</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3">Registrar entrada</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-3">
                  <v-card-title>
                    <v-btn
                      color="success"
                      class="mr-3"
                      @click="showDialogClient(true)"
                    >Nuevo cliente</v-btn>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Buscar clientes"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>

                  <v-data-table
                    :headers="getHeaders('clientes')"
                    :items="clientes"
                    :search="search"
                    :loading="loading"
                    v-model="clienteSeleccionado"
                    :single-select="true"
                    item-key="_id"
                    show-select
                    class="elevation-1"
                  ></v-data-table>
                </v-card>

                <v-btn text @click="cerrarDialog()" class="mr-2">Regresar</v-btn>
                <v-btn
                  color="primary"
                  :disabled="handleDisabledClient"
                  @click="
                    autosCliente();
                    e1 = 2;
                    data.cliente = clienteSeleccionado[0];
                  "
                >Continuar</v-btn>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card class="mb-3">
                  <v-card-title>
                    <v-text-field
                      v-model="search2"
                      append-icon="mdi-magnify"
                      label="Buscar Vehículo"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="getHeaders('autos')"
                    :items="vehiculos"
                    :search="search2"
                    :loading="loading"
                    v-model="autoSeleccionado"
                    :single-select="true"
                    item-key="_id"
                    show-select
                    class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title
                          v-if="
                            clienteSeleccionado &&
                            clienteSeleccionado?.length > 0
                          "
                        >
                          Vehículos de
                          {{
                          clienteSeleccionado[0].name +
                          " " +
                          clienteSeleccionado[0].first_lastname +
                          " " +
                          (clienteSeleccionado[0].second_lastname || "")
                          }}
                        </v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="success"
                          class="mb-2"
                          :disabled="!hayCliente"
                          @click="nuevoVehiculo"
                        >Nuevo vehículo</v-btn>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                      <v-icon small class="mr-2" @click="deleteItem(item)">mdi-cancel</v-icon>
                    </template>
                    <template v-slot:no-data>
                      <v-btn color="primary" @click="initialize">Consultar datos de nuevo</v-btn>
                    </template>
                  </v-data-table>
                </v-card>

                <v-btn text @click="handleCancel" class="mr-2">Cancelar</v-btn>
                <v-btn
                  color="primary"
                  @click="handleStep3"
                  :disabled="autoSeleccionado?.length == 0"
                >Continuar</v-btn>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-row>
                        <b class="ma-auto mt-5">Servicios</b>
                      </v-row>
                      <div>
                        <v-row justify="end"></v-row>
                        <v-row class="pa-2">
                          <v-col cols="12" sm="3">
                            <v-select
                              :items="listServiceMain"
                              v-model="data.servicio._id"
                              item-text="name"
                              item-value="_id"
                              label="Servicio*"
                              :rules="[rules.required]"
                              validate-on-blur
                              filled
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-file-input
                              counter
                              multiple
                              show-size
                              filled
                              clearable
                              ref="fileupload"
                              prepend-icon="mdi-camera"
                              label="Imágenes"
                              accept="image/*"
                              @change="onFileChange($event)"
                            ></v-file-input>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select
                              :items="listaMecanicos"
                              item-text="fullName"
                              item-value="_id"
                              v-model="data.servicio.mechanics"
                              label="Mecánico*"
                              :rules="[rules.required]"
                              validate-on-blur
                              filled
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select
                              v-model="data.servicio.washed"
                              :items="getHeaders('listaDecision')"
                              item-text="texto"
                              item-value="value"
                              label="Lavado*"
                              :rules="[rules.required]"
                              validate-on-blur
                              filled
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                      <v-divider></v-divider>
                      <v-row>
                        <b class="ma-auto mt-5">Detalle de la Orden</b>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <v-select
                            v-model="data.servicio.air"
                            :items="getHeaders('listaFuncionamiento')"
                            item-text="texto"
                            item-value="value"
                            label="Aire Acondicionado*"
                            :rules="[rules.required]"
                            validate-on-blur
                            filled
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <v-select
                            v-model="data.servicio.keyCar"
                            :items="getHeaders('listaDecision')"
                            item-text="texto"
                            item-value="value"
                            label="Llave del auto*"
                            :rules="[rules.required]"
                            validate-on-blur
                            filled
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <v-select
                            v-model="data.servicio.keyTires"
                            :items="getHeaders('listaDecision')"
                            item-text="texto"
                            item-value="value"
                            label="Seguro Llantas*"
                            :rules="[rules.required]"
                            validate-on-blur
                            filled
                          ></v-select>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field v-model="data.servicio.km" label="Kilometraje" filled></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            filled
                            v-model="data.detail"
                            name="detalles"
                            label="Detalles"
                            value
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-btn class="mr-2" text @click="data.vehiculo = {}; e1 = 2;">Cambiar vehículo</v-btn>
                <v-btn
                  color="primary"
                  @click="registrarEntradaClienteExistente"
                  :disabled="handleRegistrarEntrada"
                  :loading="dialogCargando"
                >Continuar</v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline">¿Deseas eliminar el vehiculo?</v-card-title>
        <v-card-text>Se requiere de confirmación.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="deleteItemConfirm">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCargando" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Un momento por favor...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" id="dialogVehiculo" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="editedIndex == -1">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="data.vehiculo.brand"
                  :items="listaMarca"
                  item-text="name"
                  item-value="_id"
                  label="Marca*"
                  :rules="[rules.required]"
                  validate-on-blur
                  filled
                  @change="getModelos(data.vehiculo.brand)"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="data.vehiculo.model"
                  :items="modelo"
                  item-text="name"
                  item-value="_id"
                  label="Modelo*"
                  :rules="[rules.required]"
                  validate-on-blur
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="data.vehiculo.year"
                  :items="listYears"
                  filled
                  label="Año"
                  :disabled="editedIndex !== -1"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="data.vehiculo.colour" :items="colores" filled label="Color"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="data.vehiculo.cylenders"
                  :items="[3, 4, 6, 8, 'No aplica']"
                  filled
                  label="# de Cilindros"
                  :disabled="editedIndex !== -1"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="data.vehiculo.transmission_type"
                  :items="['Automatico', 'Manual']"
                  label="Tipo Transmisión"
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Placa"
                  placeholder="VHR-3511-B"
                  v-model="data.vehiculo.license_plate"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="# de Serie"
                  placeholder="VLA-311-R31-112"
                  v-model="data.vehiculo.serial_number"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="data.vehiculo.description"
                  filled
                  name="extras"
                  label="Descripcion / Detalles"
                  value
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="editedItem.brand"
                  :items="listaMarca"
                  item-text="name"
                  item-value="_id"
                  label="Marca"
                  filled
                  @change="getModelos(editedItem.brand)"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="editedItem.model"
                  :items="modelo"
                  item-text="name"
                  item-value="_id"
                  label="Modelo"
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete v-model="editedItem.year" :items="listYears" filled label="Año"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="editedItem.colour" :items="colores" filled label="Color"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="data.vehiculo.cylenders"
                  :items="[3, 4, 6, 8, 'No aplica']"
                  filled
                  label="# de Cilindros"
                  :disabled="editedIndex !== -1"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  placeholder="VHR-3511-B"
                  label="Placa"
                  v-model="editedItem.license_plate"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="# de Serie"
                  placeholder="VLA-311-R31-112"
                  v-model="editedItem.serial_number"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="data.vehiculo.transmission_type"
                  :items="['Automatico', 'Manual']"
                  label="Tipo Transmisión"
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  filled
                  name="extras"
                  label="Descripcion / Detalles"
                  value
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="handleDisabledVehi"
            @click="editedIndex == -1
              ? registrarVehiculo()
              : guardarVehiculo(editedItem._id)"
          >
            {{
            editedIndex !== -1
            ? "Editar vehículo"
            : "Registrar vehículo"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="statusDialogClient" id="dialogNewClient" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Alta Cliente</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="pa-2">
              <v-col cols="12" sm="12">
                <v-text-field
                  label="Nombre*"
                  placeholder="Juan"
                  v-model="clienteNuevo.name"
                  :rules="[rules.required]"
                  validate-on-blur
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="clienteNuevo.first_lastname"
                  :rules="[rules.required]"
                  validate-on-blur
                  label="Apellido Paterno*"
                  placeholder="López"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Apellido Materno"
                  v-model="clienteNuevo.second_lastname"
                  placeholder="Perez"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="clienteNuevo.telephones"
                  :rules="[rules.required, rules.min, rules.regex]"
                  validate-on-blur
                  label="Celular*"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="clienteNuevo.email"
                  :rules="[rules.regexEmail]"
                  label="Correo"
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="showDialogClient(false)">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="registrarCliente">Registrar Cliente</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import moment from "moment";

import ApiService from "../../services/apis";
import servicesService from "../../services/services";
import employeeService from "../../services/employee";
import vehicleService from "../../services/vehicule";
import orderService from "../../services/order";
import customerService from "../../services/customer";
import AppIcon from "@/components/ui/AppIcon.vue";

export default {
  name: "NuevoCliente",
  components: { AppIcon },
  data() {
    return {
      listYears: [],
      listaMecanicos: [],
      listServiceMain: [],
      listaMarca: [],
      statusDialogClient: false,
      images: null,
      clienteNuevo: {},
      rules: {},

      //VIEJOS

      dialogCargando: false,
      loading: false,

      dialogPrincipal: false,

      date: null,
      menu: false,
      pagina: 1,
      e1: 1,
      clienteSeleccionado: [],
      autoSeleccionado: [],
      search: null,
      modelo: [],
      search2: null,
      orden: {},
      colores: [],
      clientes: [],
      hayCliente: false,
      vehiculos: [],
      data: {
        detail: "",
        images: [],
        cliente: {},
        vehiculo: { model: null },
        servicio: { _id: 0, mechanics: "", description: "" },
      },
      existingImages: [],
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {
        images: [],
      },
      defaultItem: {},
      hoy: new Date(),
      sesion: JSON.parse(sessionStorage.getItem("sesion")),
      attrs: "",
      on: "",
    };
  },
  created() {
    moment.locale("es");
    this.hoy = moment().format("L");
    this.initialize();
    this.getAllData();
    this.rules = this.getRules();
    this.listYears = vehicleService.getYearsAvailable();
    this.colores = vehicleService.getColors();
  },
  methods: {
    showDialogClient(status) {
      this.statusDialogClient = status;
    },
    handleStep3() {
      this.data.vehiculo = this.autoSeleccionado[0];
      this.e1 = 3;
    },
    handleCancel() {
      this.e1 = 1;
    },
    async registrarCliente() {
      await customerService.create(this.clienteNuevo);
      this.initialize();
      this.showDialogClient(false);
    },
    nuevoVehiculo() {
      this.editedItem = {};
      this.autoSeleccionado.pop();
      this.dialog = true;
    },
    formatDate(date) {
      if (!date) return "No disponible";
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    async initialize() {
      try {
        this.loading = true;
        const clientes = await ApiService.cliente();
        this.clientes = clientes.filter(
          (cliente) =>
            cliente._id != this.sesion.employee.branch.general_public_client
        );
        if (this.clientes?.length > 0) {
          this.clientes = this.clientes.map((cliente) => {
            cliente.last_visit = this.formatDate(cliente?.last_visit);
            return cliente;
          });
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        return err;
      }
      this.getModelos();
    },
    async getAllData() {
      const [marca] = await Promise.all([
        await ApiService.marcaByFilter({ type: 2 }),
      ]);

      this.listaMarca = marca.data;
      this.listServiceMain = await servicesService.getServicesMain();
      this.listaMecanicos = await employeeService.getMechanics();
    },
    editItem(item) {
      this.getModelos(item?.model?.brand?._id);
      this.editedIndex = this.vehiculos.indexOf(item);
      if (item?.images?.length > 0) {
        this.onFileChange(item.images);
      }
      this.editedItem = Object.assign({}, item);
      this.editedItem.model = this.editedItem.model
        ? this.editedItem.model
        : { brand: { _id: null, name: null }, _id: null, name: null };
      this.editedItem.brand = this.editedItem.model.brand
        ? this.editedItem.model.brand
        : { model: { _id: null, name: null }, _id: null, name: null };
      this.editedItem.indexYear = this.listYears.findIndex(
        (i) => i == item.year
      );
      this.editedItem.year = this.listYears[this.editedItem.indexYear];
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.vehiculos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      try {
        this.closeDelete();
        await ApiService.vehiculoEditar(this.editedItem._id, { status: 0 });
        Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Vehiculo eliminado con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
        this.autosCliente();
      } catch (err) {
        return err;
      }
    },
    clearVehiculeData() {
      this.data = {
        images: [],
        detail: "",
        cliente: {},
        vehiculo: { model: null },
        servicio: { _id: 0, mechanics: "", description: "" },
      };
    },
    close() {
      this.existingImages = [];
      this.clearVehiculeData();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async getModelos(marca) {
      console.log(this.getModelos.name);
      const modelo = await ApiService.modeloByFilter({ brand: marca });
      this.modelo = modelo.data;
    },
    dataInitFinOrden() {
      this.clienteSeleccionado = [];
      this.autoSeleccionado = [];
      this.data = {
        detail: "",
        cliente: {},
        vehiculo: {},
        servicio: { _id: 0, mechanics: "", description: "" },
      };
      this.pagina = 1;
      this.e1 = 1;
    },
    cerrarDialog() {
      this.$refs.fileupload.value = null;
      this.pagina = 1;
      this.e1 = 1;
      this.dialogPrincipal = false;
      this.$bus.$emit("actualizaOrden", 1);
      this.dataInitFinOrden();
    },
    async guardarVehiculo(id) {
      try {
        this.existingImages = [];
        this.dialogCargando = true;
        const obj = {
          client: this.editedItem.client._id,
          license_plate: this.editedItem.license_plate,
          mileage: this.editedItem.mileage,
          colour: this.editedItem.colour,
          description: this.editedItem.description,
          model: this.editedItem.model,
          serial_number: this.editedItem?.serial_number,
          year: this.editedItem.year,
          images: this.editedItem?.images,
        };
        await ApiService.vehiculoEditar(id, obj);
        this.dialogCargando = false;
        Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Vehiculo editado con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
        this.autosCliente();
        this.close();
      } catch (err) {
        this.dialogCargando = false;
        return err;
      }
    },
    async registrarEntradaClienteExistente() {
      try {
        this.dialogCargando = true;
        const ordenData = {
          clienteId: this.autoSeleccionado[0].client._id,
          vehiculoId: this.data.vehiculo._id,
          detail: this.data.detail,
          servicioId: this.data.servicio._id,
          mechanicId: this.data.servicio.mechanics,
          userId: this.sesion._id,
          employeeId: this.sesion.employee._id,
          branchId: this.sesion.employee.branch._id,
          images: this.data.images,
          air: this.data.servicio.air,
          keyCar: this.data.servicio.keyCar,
          keyTires: this.data.servicio.keyTires,
          km: this.data.servicio.km,
          washed: this.data.servicio.washed,
        };

        this.orden = await orderService.createOrder(ordenData);
        this.dialogCargando = false;
        this.cerrarDialog();
      } catch (err) {
        this.dialogCargando = false;
        Swal.fire({
          icon: "error",
          title: "Atención!",
          text: `${err.data.message}`
        });
        return err;
      }
    },
    async autosCliente() {
      try {
        this.dialogCargando = true;
        let filters = {};
        if (this.clienteSeleccionado?.length > 0) {
          filters = {
            client: this.clienteSeleccionado[0]._id,
            status: { $ne: "0" },
          };
          this.hayCliente = true;
        } else {
          filters = {
            status: { $ne: "0" },
          };
          this.hayCliente = false;
        }
        const autos = await ApiService.vehiculoByFilter(filters);
        this.dialogCargando = false;
        this.vehiculos = autos.data;
        if (this.vehiculos?.length > 0) {
          this.vehiculos = this.vehiculos.map((vehiculo) => {
            vehiculo.updatedAt = this.formatDate(vehiculo?.updatedAt);
            return vehiculo;
          });
        }
      } catch (err) {
        this.dialogCargando = false;
        return err;
      }
    },
    async registrarVehiculo() {
      try {
        this.existingImages = [];
        this.dialogCargando = true;
        let auto = {
          ...this.data.vehiculo,
          client: this.clienteSeleccionado[0]._id,
        };
        await ApiService.vehiculoNuevo(auto);
        Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Vehiculo registrado con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
        this.dialogCargando = false;
        this.autosCliente();
        this.close();
      } catch (err) {
        this.dialogCargando = false;
        return err;
      }
    },
    async onFileChange(files) {
      const filePathsPromises = [];
      files.forEach((file) => {
        filePathsPromises.push(this.toBase64(file));
      });
      let filePaths = await Promise.all(filePathsPromises);
      if (typeof filePaths[0] == "undefined") {
        filePaths = [];
      }

      this.data.images = [...filePaths, ...this.existingImages];

      // if (this.editedIndex !== -1) {
      //   this.editedItem.images = filePaths.map((base64File) => ({
      //     base64File,
      //   }));
      //   if (this.existingImages.length > 0) {
      //     this.editedItem.images = [
      //       ...this.editedItem.images,
      //       ...this.existingImages,
      //     ];
      //   }
      // } else {
      //   this.data.vehiculo.images = filePaths.map((base64File) => ({
      //     base64File,
      //   }));
      //   if (this.existingImages.length > 0) {
      //     this.data.vehiculo.images = [
      //       ...this.data?.vehiculo?.images,
      //       ...this.existingImages,
      //     ];
      //   }
      // }
      this.existingImages = [];
    },
    toBase64(file) {
      if (file && file.name) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      } else {
        if (file) {
          this.existingImages.push(file);
        }
      }
    },
    getHeaders(index) {
      const headers = {
        autos: [
          {
            text: "Vehículo",
            align: "start",
            sortable: true,
            value: "model.name",
          },
          { text: "Marca", value: "model.brand.name" },
          { text: "Año", value: "year" },
          { text: "Color", value: "colour" },
          { text: "Serie", value: "serial_number" },
          { text: "Placas", value: "license_plate" },
          { text: "Ultima Fecha", value: "updatedAt" },
          { text: "Editar", value: "actions" },
        ],
        clientes: [
          {
            text: "Nombre",
            align: "start",
            sortable: true,
            value: "name",
          },
          { text: "Apellido Paterno", value: "first_lastname" },
          { text: "Apellido Materno", value: "second_lastname" },
          { text: "Ult. Visita", value: "last_visit" },
        ],
        listaDecision: [
          {
            texto: "Si",
            value: 1,
          },
          {
            texto: "No",
            value: 2,
          },
        ],
        listaFuncionamiento: [
          {
            texto: "Si",
            value: 1,
          },
          {
            texto: "No",
            value: 2,
          },
          {
            texto: "No Funciona",
            value: 3,
          },
        ],
      };

      return headers[index];
    },
    getRules() {
      return {
        required: (value) => !!value || "Requerido.",
        min: (v) => v?.length >= 10 || "Minimo 10 caracteres",
        regex: (v) => /^\d{10}$/.test(v) || "Solo digitos y al menos 10",
        regexEmail: (v) =>
          /^[^@]+@[^@]+\.[a-zA-Z;@.\d\w\D\W]{2,}$/.test(v) ||
          "Formato no válido",
      };
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    handleDisableModelo() {
      console.log("Estoy entrando");
      if (this.editedIndex !== -1) return true;
      return this.data?.vehiculo?.brand ? false : true;
    },
    handleRegistrarEntrada() {
      const { _id, mechanics, km, air, keyTires, washed, keyCar } =
        this.data?.servicio;
      console.log(_id, mechanics, km, air, keyTires, washed, keyCar);
      // Variables a verificar
      const variables = [_id, mechanics, km, air, keyTires, washed, keyCar];

      // Retorna false si alguna de las variables es null o undefined
      let resultado = false
      for (const variable of variables) {
        if (variable == null || variable == undefined || variable == '') {
          console.log("entre")
          resultado = true;
          break;
        }
      }

      return resultado
    },
    handleDisabledVehi() {
      console.log("Estoy entrando 2");
      const { brand, model } = this.data?.vehiculo;
      if (this.editedIndex === -1) {
        return brand && model ? false : true;
      } else {
        return false;
      }
    },
    formTitle() {
      console.log("Estoy entrando 3");
      return this.editedIndex === -1
        ? "Alta nuevo vehículo"
        : "Editar vehículo " + this.editedItem.model.name;
    },
    handleDisabledClient() {
      return this.clienteSeleccionado.length > 0 ? false : true;
    },
  },
};
</script>

<style scoped>
.service-disabled {
  cursor: no-drop;
  opacity: 0.5;
}
</style>
